import { tsInitVue } from './js-utils'
// import type EventTopicLogoManager from '../js/vue-components/event-topic-logo-manager.vue'

document.addEventListener('DOMContentLoaded', function () {
  const certEl = document.querySelector('div[data-is="CompletionCertificatePdfEditor"]')
  if (certEl instanceof HTMLElement) {
    (async (): Promise<void> => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const CompletionCertificatePdfEditor = await import('./vue-components/completion-certificate-pdf-editor.vue')
      const frameW = parseInt(certEl.dataset.pdfFrameW || '')
      const frameH = parseInt(certEl.dataset.pdfFrameH || '')

      window.pdfEditor = tsInitVue(CompletionCertificatePdfEditor.default, certEl, {
        uploadUrl: certEl.dataset.uploadUrl,
        previewUrl: certEl.dataset.previewUrl,
        pdfFrameW: isNaN(frameW) ? null : frameW,
        pdfFrameH: isNaN(frameH) ? null : frameH,
        withTopics: certEl.dataset.withTopics != 'false',
      })
    })()
  }

  const logoEl = document.querySelector('div[data-is="EventTopicLogoManager"]')
  if (logoEl instanceof HTMLElement) {
    (async (): Promise<void> => {
      const EventTopicLogoManager = await import('./vue-components/event-topic-logo-manager.vue')

      window.logoManager = tsInitVue(EventTopicLogoManager.default, logoEl, {
        url: logoEl.dataset.listUrl ?? '',
        imagePlaceholderUrl: logoEl.dataset.imagePlaceholderUrl ?? '',
        uploadUrl: logoEl.dataset.uploadUrl ?? ''
      })
    })()
  }
})
